<template>
    <section id="content" class="gray-area">

        <!-- >>> BOOKING --------------------------------------------------- -->
        <div class="container" v-if="show_BookingConfirmation === true">
            <!-- >>> BreadCrumbs - Row -->
            <div class="row">
                <sdr-breadcrumbs active_item="fifth" module="booking"></sdr-breadcrumbs>
            </div>
            <!-- <<< BreadCrumbs - Row -->

            <!-- >>> Content - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ bookingconfirmation[getCurrentLocale] }}</h1>
                </div>


                <!-- >>>  Left Side: : 'Confirmation' ---------------------- -->
                <div id="main" class="col-sm-8 col-md-9">
                    <!-- >>> Payment Details -->
                    <div class="booking-information sdr-box">
                        <h2>{{ pleaseselectconfirmation[getCurrentLocale] }} {{ getBookingProcessBookingResults.bookingCode }}, {{ pleaseselectconfirmation2[getCurrentLocale] }} {{ getBookingProcessBookingResults.idInvoice }}</h2>
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-recommend icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ thankyou[getCurrentLocale] }}</h4>
                                <p>{{ emailhassent[getCurrentLocale] }}</p>
                            </div>
                        </div>
                        <hr />
                        <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                        <p>{{ forsecurity[getCurrentLocale] }}</p>
                        <br />
                        <p class="red-color">{{ creditcard[getCurrentLocale] }}.</p>
                    </div>
                    <!-- <<< Payment Details -->


                    <!-- >>> Booking Details -->
                    <br />
                    <div id="flight-features" class="tab-container">
                        <!-- >>> TabHeader:  -->
                        <ul class="tabs">
                            <li class="active"><a href="#flight-details" data-toggle="tab">{{ yourinvoicetotal[getCurrentLocale] }}</a></li>
                        </ul>
                        <!-- <<< TabHeader:  -->


                        <!-- >>> Tab Content: -->
                        <div class="tab-content">
                            <!-- --------------------------------------- -->
                            <!-- >>> Tab: 'flight-details' -->
                            <div class="tab-pane fade in active" id="flight-details">
                                <!-- >>> Total::Total::Total -->
                                <button class="btn-large full-width totalbutton"  style="cursor: initial;">{{ Number(getBookingProcessBookingResults.totalBooking) | rndAmntRUAFWZ }}<br /><span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span></button>
                                <!-- <<< Total::Total::Total -->
                            </div>
                            <!-- <<< Tab: 'flight-details' -->
                            <!-- --------------------------------------- -->
                        </div>
                        <!-- <<< Tab Content: -->
                    </div>
                    <!-- <<< Booking Details -->
                </div>
                <!-- <<<  Left Side: : 'Confirmation' ---------------------- -->


                <!-- Begin:Content-SideBar-Booking ------------------------- -->
                <div class="sidebar col-sm-4 col-md-3">
                    <sdr-contact-box></sdr-contact-box>
                </div>
                <!-- End:Content-SideBar-Booking --------------------------- -->
            </div>
            <!-- <<< Content - Row -->
        </div>
        <!-- <<< BOOKING --------------------------------------------------- -->





        <!-- >>> BLANKO ---------------------------------------------------- -->
        <div class="container" v-if="show_BlankoConfirmation === true">
            <!-- >>> BreadCrumbs - Row -->
            <div class="row">
                <sdr-breadcrumbs active_item="fifth" module="services"></sdr-breadcrumbs>
            </div>
            <!-- <<< BreadCrumbs - Row -->

            <!-- >>> Content - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ bookingconfirmation[getCurrentLocale] }}</h1>
                </div>


                <!-- >>>  Left Side: : 'Confirmation' ---------------------- -->
                <div id="main" class="col-sm-8 col-md-9">
                    <!-- >>> Payment Details -->
                    <div class="booking-information sdr-box">
                        <h2>{{ pleaseselectconfirmation[getCurrentLocale] }} {{ getServicesProcessBookingResults.newSpecialsResponse.invoice.bookingCode }}, {{ pleaseselectconfirmation2[getCurrentLocale] }} {{ getServicesProcessBookingResults.newSpecialsResponse.invoice.idInvoice }}</h2>
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-recommend icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ thankyou[getCurrentLocale] }}</h4>
                                <p>{{ emailhassent[getCurrentLocale] }}</p>
                            </div>
                        </div>
                        <hr />
                        <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                        <p>{{ forsecurity[getCurrentLocale] }}</p>
                        <br />
                        <p class="red-color">{{ creditcard[getCurrentLocale] }}.</p>
                    </div>
                    <!-- <<< Payment Details -->


                    <!-- >>> Booking Details -->
                    <br />
                    <div id="flight-features" class="tab-container">
                        <!-- >>> TabHeader:  -->
                        <ul class="tabs">
                            <li class="active"><a href="#flight-details" data-toggle="tab">{{ yourinvoicetotal[getCurrentLocale] }}</a></li>
                        </ul>
                        <!-- <<< TabHeader:  -->


                        <!-- >>> Tab Content: -->
                        <div class="tab-content">
                            <!-- --------------------------------------- -->
                            <!-- >>> Tab: 'flight-details' -->
                            <div class="tab-pane fade in active" id="flight-details">
                                <!-- >>> Total::Total::Total -->
                                <button class="btn-large full-width totalbutton" style="cursor: initial;">{{ Number(getServicesProcessBookingResults.newSpecialsResponse.amount) | rndAmntRUAFWZ }}<br /><span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span></button>
                                <!-- <<< Total::Total::Total -->
                            </div>
                            <!-- <<< Tab: 'flight-details' -->
                            <!-- --------------------------------------- -->
                        </div>
                        <!-- <<< Tab Content: -->
                    </div>
                    <!-- <<< Booking Details -->
                </div>
                <!-- <<<  Left Side: : 'Confirmation' ---------------------- -->


                <!-- Begin:Content-SideBar-Booking ------------------------- -->
                <div class="sidebar col-sm-4 col-md-3">
                    <sdr-contact-box></sdr-contact-box>
                </div>
                <!-- End:Content-SideBar-Booking --------------------------- -->
            </div>
            <!-- <<< Content - Row -->
        </div>
        <!-- <<< BLANKO ---------------------------------------------------- -->





        <!-- >>> REBOOKING ------------------------------------------------- -->
        <div class="container" v-if="show_RebookingConfirmation === true">
            <!-- >>> BreadCrumbs - Row -->
            <div class="row">
                <sdr-breadcrumbs active_item="sixth" module="rebooking"></sdr-breadcrumbs>
            </div>
            <!-- <<< BreadCrumbs - Row -->

            <!-- >>> Content - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;"><span class="index"><i
                                class="soap-icon-arrow-right circle"></i></span>{{ bookingconfirmation[getCurrentLocale] }}</h1>
                </div>


                <!-- >>>  Left Side: : 'Confirmation' ---------------------- -->
                <div id="main" class="col-sm-8 col-md-9">
                    <!-- >>> Payment Details -->
                    <div class="booking-information sdr-box">
                        <h2>{{ pleaseselectconfirmation[getCurrentLocale] }} {{ get_RebookingProcessRebookingResults.bookingCode }}, {{ pleaseselectconfirmation2[getCurrentLocale] }} {{ get_RebookingProcessRebookingResults.idInvoice }}</h2>
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-recommend icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ thankyou[getCurrentLocale] }}</h4>
                                <p>{{ emailhassent[getCurrentLocale] }}</p>
                            </div>
                        </div>
                        <hr />
                        <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                        <p>{{ forsecurity[getCurrentLocale] }}</p>
                        <br />
                        <p class="red-color">{{ creditcard[getCurrentLocale] }}.</p>
                    </div>
                    <!-- <<< Payment Details -->


                    <!-- >>> Booking Details -->
                    <br />
                    <div id="flight-features" class="tab-container">
                        <!-- >>> TabHeader:  -->
                        <ul class="tabs">
                            <li class="active"><a href="#flight-details" data-toggle="tab">{{ yourinvoicetotal[getCurrentLocale]
                            }}</a></li>
                        </ul>
                        <!-- <<< TabHeader:  -->


                        <!-- >>> Tab Content: -->
                        <div class="tab-content">
                            <!-- --------------------------------------- -->
                            <!-- >>> Tab: 'flight-details' -->
                            <div class="tab-pane fade in active" id="flight-details">
                                <!-- >>> Total::Total::Total -->
                                <button class="btn-large full-width totalbutton" style="cursor: initial;">{{ Number(get_RebookingProcessRebookingResults.rebookingPrice) | rndAmntRUAFWZ }}<br /><span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span></button>
                                <!-- <<< Total::Total::Total -->
                            </div>
                            <!-- <<< Tab: 'flight-details' -->
                            <!-- --------------------------------------- -->
                        </div>
                        <!-- <<< Tab Content: -->
                    </div>
                    <!-- <<< Booking Details -->
                </div>
                <!-- <<<  Left Side: : 'Confirmation' ---------------------- -->


                <!-- Begin:Content-SideBar-Booking ------------------------- -->
                <div class="sidebar col-sm-4 col-md-3">
                    <sdr-contact-box></sdr-contact-box>
                </div>
                <!-- End:Content-SideBar-Booking --------------------------- -->
            </div>
            <!-- <<< Content - Row -->
        </div>
        <!-- <<< REBOOKING ------------------------------------------------- -->




        <!-- >>> ERROR ----------------------------------------------------- -->
        <div class="container" v-if="show_Error_Container === true">
            <!-- >>> BreadCrumbs - Row -->
            <div class="row">
                <sdr-breadcrumbs module="booking"></sdr-breadcrumbs>
            </div>
            <!-- <<< BreadCrumbs - Row -->

            <!-- >>> Content - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px; color: red;">
                        <span class="index">
                            <i class="soap-icon-error circle"></i>
                        </span>
                        {{ pleaseselectoverview[getCurrentLocale] }}
                    </h1>
                </div>

                <div id="main" class="col-sm-8 col-md-9">
                    <div class="booking-information sdr-box" style="border: 1px solid red;">
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-notice icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ explanation[getCurrentLocale] }}</h4>
                                <p>{{ explanationsub[getCurrentLocale] }}</p>
                            </div>
                            <a href="https://www.sundair.com" class="print-button button btn-small sundair">{{ goback[getCurrentLocale] }}</a>
                        </div>
                        <hr />
                        <br />
                        <h2>{{ solution[getCurrentLocale] }}</h2>
                        <p v-html="solutiontext[getCurrentLocale]"></p>
                        <br />
                        <hr />
                        <br />
                        <div style="display: flex; justify-content: space-between;">
                            <div>
                                <p class="red-color">{{ paymentmethod[getCurrentLocale] }}</p>
                                <br />
                                <a href="#" class="red-color underline view-link">https://www.sundair.com/</a>
                            </div>
                            <div style="display: flex; justify-content: end;">
                                <img src='/res/images/icon/warning.png' width='25%' />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Begin:Content-SideBar-Booking ------------------------- -->
                <div class="sidebar col-sm-4 col-md-3">
                    <sdr-contact-box></sdr-contact-box>
                </div>
                <!-- End:Content-SideBar-Booking --------------------------- -->
            </div>
            <!-- <<< Content - Row -->
        </div>
        <!-- <<< ERROR ----------------------------------------------------- -->
    </section>
</template>

<script>
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function () {

            return {
                bookingconfirmation: {
                    en: 'Step 5: We confirm your booking!',
                    de: 'Schritt 5: Hiermit bestätigen wir Ihre Buchung!',
                },
                thankyou: {
                    en: 'Thank You. Your booking order is confirmed now.',
                    de: 'Vielen Dank. Ihre Buchungsanfrage ist hiermit bestätigt.',
                },
                pleaseselectconfirmation: {
                    en: 'Your booking code is',
                    de: 'Ihr Buchungscode lautet'
                },
                pleaseselectconfirmation2: {
                    en: 'Your Invoice-Id is:',
                    de: 'Ihre Rechnungsnummer ist:'
                },
                emailhassent: {
                    en: 'A confirmation e-mail has been sent to your provided e-mail address.',
                    de: 'An Ihre angegebene E-Mail-Adresse wurde eine Bestätigungs-E-Mail gesendet.',
                },
                paymentmethod: {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                yourinvoicetotal: {
                    en: 'Invoice Total:',
                    de: 'Rechnungssumme:',
                },
                // >>> --------------------------

                pleaseselectoverview: {
                    en: 'Step 5: Something has gone wrong!',
                    de: 'Schritt 5: Etwas ist schief gelaufen!'
                },
                aborttitle: {
                    en: 'Something has gone wrong.',
                    de: 'Etwas ist schief gelaufen.',
                },
                explanation: {
                    en: 'Dear customer, we are sorry. Something went wrong.',
                    de: 'Sehr geehrter Kunde, es tut uns leid. Etwas ist schief gelaufen.',
                },
                explanationsub: {
                    en: 'You can see the next steps below.',
                    de: 'Die weitere Schritte sehen Sie unten.',
                },
                solution: {
                    en: 'What can i do?',
                    de: 'Was kann ich tun?',
                },
                goback: {
                    en: 'BACK TO THE HOMEPAGE',
                    de: 'ZURÜCK ZUR HOMEPAGE',
                },
                goback2: {
                    en: 'Back to: ',
                    de: 'Zurück zur: ',
                },
                paymentmethod: {
                    en: 'Your Payment method: Credit card',
                    de: 'Ihre Zahlungsmethode: Kreditkarte',
                },
                solutiontext: {
                    en: 'We are sorry, your booking could not be made. Please try again later. <br /><br />Should your credit card still be charged, the amount will be refunded to you immediately.<br /><br />If you still have a problem or need further help, please contact our customer service..',
                    de: 'Es tut uns leid, Ihre Buchung konnte nicht durchgeführt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.<br /><br />Sollte Ihre Kreditkarte trotzdem belastet worden sein, wird Ihnen der Betrag umgehend zurückerstattet.<br /><br />Wenn weiterhin ein Problem bestehlt oder Sie weitere Hilfe benötigen, wenden Sie sich gerne an unseren Kundenservice.',
                },
                // >>> --------------------------
                alertsuccessful: {
                    en: 'Successful!',
                    de: 'Erfolgreich!',
                },
                alertyourbooking: {
                    en: 'Your booking has been made.',
                    de: 'Ihre Buchung ist erfolgt.',
                },
                // >>> --------------------------
                show_BookingConfirmation: false,    // switch
                show_BlankoConfirmation: false,     // switch
                show_RebookingConfirmation: false,  // switch
                show_Error_Container: false,        // switch
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getBookingProcessBookingObject',
                'getBookingProcessBookingResults',
                'getServicesProcessBookingResults',
                'get_RebookingProcessRebookingResults'
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            let me = this;


            me.$toc('>>> components/checkout/success/Success.vue >>> created');
            if (this.$router.currentRoute.params.modulo !== undefined) {
                this.actn_call_checkTransactionId(this.$router.currentRoute.params.modulo);
                // >>> ----------------------------------------
                eventBus.$on('readytoprocessbooking', this.onEmit_ReadyToDoPrcocessBooking);
                eventBus.$on('readytoshowbookingsconfirmationoncheckout', this.onEmit_ReadyToShow_Booking_Confirmation);
                eventBus.$on('errorinconfirmation', this.onEmit_ErrorInConfirmation);
            }

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function () {

            let me = this;


            me.$toc('>>> components/checkout/success/Success.vue >>> beforeDestroy');
            // >>> ----------------------------------------
            eventBus.$off('readytoprocessbooking', this.onEmit_ReadyToDoPrcocessBooking);
            eventBus.$off('readytoshowbookingsconfirmationoncheckout', this.onEmit_ReadyToShow_Booking_Confirmation);
            eventBus.$off('errorinconfirmation', this.onEmit_ErrorInConfirmation);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_checkTransactionId',
                'actn_call_processBooking',
                'actn_call_registrationNewSpecials',
                'actn_call_processRebooking'
            ]),


            /******************************************************************* 'Listeners - eventbus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToDoPrcocessBooking()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_ReadyToDoPrcocessBooking: function (data) {

                let me = this,
                    myObjectToSend = {};


                me.$toc('>>> components/checkout/success/Success.vue >>> onEmit_ReadyToDoPrcocessBooking');
                switch (data.callName.toUpperCase()) {
                    case 'TICKET_BOOKING':
                        myObjectToSend = data.ticketBookingRQObject;
                        this.actn_call_processBooking(myObjectToSend);
                        break;
                    case 'BLANKO':
                        myObjectToSend = data.newSpecialsRQObject;
                        this.actn_call_registrationNewSpecials(myObjectToSend);
                        break;
                    case 'REBOOKING':
                        myObjectToSend = data.rebookingRQObject;
                        this.actn_call_processRebooking(myObjectToSend);
                        break;
                    default:
                        break;
                }

            }, // eo function onEmit_ReadyToDoPrcocessBooking()


            /*******************************************************************
            * onEmit_ReadyToShow_Booking_Confirmation()
            *
            * Desc: ProcessBooking or Colleagues was done.
            * Note:
            *
            */
            onEmit_ReadyToShow_Booking_Confirmation: function (data) {

                let me = this,
                    callName = null;


                me.$toc('>>> components/checkout/success/Success.vue >>> onEmit_ReadyToShow_Booking_Confirmation');
                // >>> --------------------------
                if (data.totalBooking !== undefined) {
                    callName = 'TICKET_BOOKING';
                }
                if (data.newSpecialsResponse !== undefined) {
                    callName = 'BLANKO';
                }
                if (data.rebookingPrice !== undefined) {
                    callName = 'REBOOKING';
                }


                // >>> --------------------------
                switch (callName) {
                    case 'TICKET_BOOKING':
                        this.show_BookingConfirmation = true;
                        this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
                        break;
                    case 'BLANKO':
                        this.show_BlankoConfirmation = true;
                        this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
                        break;
                    case 'REBOOKING':
                        this.show_RebookingConfirmation = true;
                        this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
                        break;
                    default:
                        break;
                }

            }, // eo function onEmit_ReadyToShow_Booking_Confirmation()


            /*******************************************************************
            * onEmit_ErrorInConfirmation()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_ErrorInConfirmation: function (data) {

                let me = this;


                me.$toc('>>> components/checkout/success/Success.vue >>> onEmit_ErrorInConfirmation');
                this.show_Error_Container = true;

            }, // eo function onEmit_ErrorInConfirmation()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .booking-information>.booking-confirmation .main-message {
        color: #9F4378;
    }

    dl.term-description dt {
        color: #9e4d84;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em;
        /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }

    .swal-button {
        padding: 0px !important;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
        h1 {
            font-size: 1.5em;
        }

        h2 {
            font-size: 1.4em;
        }

        button.btn-large,
        input[type="button"].button.btn-large,
        a.button.btn-large {
            font-size: 1.0em;
        }

        .booking-information {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/checkout/success/Success.vue